import React, { useEffect, useState } from "react";
import { utils } from "../../utils";
import { ProgressBar } from "primereact/progressbar";
import "./newRelease.css";

const NewRelease = () => {
    const [releaseDownProgress, setNewReleaseDownProgress] = useState(0);
    const [showProgress, setShowProgress] = useState<boolean>(false);
    const [newReleaseVersion, setNewReleaseVersion] = useState<string>("")

    useEffect(() => {
        if (utils.isElectronBuild()) {
            window?.myAPI?.DownloadProgress("DownloadProgress", (data) => {
                if (data !== undefined && data !== "") {
                    const percentage = Math.round(data.percent);

                    if (percentage <= 100) {
                        setNewReleaseDownProgress(percentage);
                        setNewReleaseVersion(data.newReleaseVersion);

                        if (!showProgress) {
                            setShowProgress(true);
                        }

                        if (percentage === 100) {
                            setTimeout(() => {
                                setShowProgress(false);
                            }, 5000);
                        }
                    }
                }
            });
        }
    }, [showProgress]);

    return (
        <>
            {showProgress ? (
                <div className="release-down-progress">
                    <div className="header">
                        <h6>LiveAdmins Live Chat New Release (<strong>{newReleaseVersion}</strong>)</h6>
                    </div>
                    <div className="body">
                        <span className="mr-1">Downloading</span>
                        <ProgressBar value={releaseDownProgress} />
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default NewRelease;
